/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum tagEntityTypeEnum {
    USER = 'user',
    PLAN = 'plan',
    GRANT = 'grant',
    POOL = 'pool',
    QUERY = 'query',
    OTHER = 'other',
    ANY = 'any',
}